export const ASSETS = {
  "logos": {
    "splash": {
      "path": "https://ucarecdn.com/dac37dfb-d2a9-4b0b-bf04-c86978ed718c/graph.svg",
      "width": 300,
      "height": 300
    }
  },
  "backgrounds": {
    "failing_server_room": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4275b22393c7449d91753801b750f013/main/preview/assets/backgrounds/failing_server_room.png",
      "height": 1080,
      "transparent": false,
      "width": 1920
    },
    "main_menu_neural_network": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/9a50524611414bb19f5b7a7a28c33f74/b6835189644646fead99b6b7c8f8f0d4/preview/assets/backgrounds/main_menu_neural_network.png",
      "height": 1080,
      "transparent": false,
      "width": 1920
    }
  },
  "icons": {
    "achievement_star": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/b32f4dabee2c4058a784268726904eda/main/preview/assets/icons/achievement_star.png",
      "height": 128,
      "width": 128
    },
    "antivirus": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/060dcd915bec4925953fca1550f4904a/15e9eea33238438b9ec5785336a3d086/preview/assets/icons/antivirus.svg",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "data": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/b32f4dabee2c4058a784268726904eda/main/preview/assets/icons/data.png",
      "height": 128,
      "width": 128
    },
    "emotion_wave_heart": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/6fb4ecfb2d3a40aebcd4d4db44119293/main/preview/assets/icons/emotion_wave_heart.png",
      "height": 128,
      "width": 128
    },
    "energy": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/b32f4dabee2c4058a784268726904eda/main/preview/assets/icons/energy.png",
      "height": 128,
      "width": 128
    },
    "language": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/b32f4dabee2c4058a784268726904eda/main/preview/assets/icons/language.png",
      "height": 128,
      "width": 128
    },
    "logic": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/634ff5a6c78547d09cb0ca492597e7c5/main/preview/assets/icons/logic.png",
      "height": 128,
      "width": 128
    },
    "memory": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/419ebeff05fe4eb9b6fc0a3a5a9da93f/main/preview/assets/icons/memory.png",
      "height": 128,
      "width": 128
    },
    "pattern": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/b32f4dabee2c4058a784268726904eda/main/preview/assets/icons/pattern.png",
      "height": 128,
      "width": 128
    },
    "purity": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/e9f8c7b6a5d4e3f2a1b0c9d8e7f6a5b4/main/preview/assets/icons/purity.svg",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "time": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/b32f4dabee2c4058a784268726904eda/main/preview/assets/icons/time.png",
      "height": 128,
      "width": 128
    },
    "virus": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/060dcd915bec4925953fca1550f4904a/15e9eea33238438b9ec5785336a3d086/preview/assets/icons/virus.svg",
      "width": 128,
      "height": 128,
      "transparent": true
    },

    /* Added icons from Project B to support discovered elements imagery */
    "empathy": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/empathy.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "knowledge": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/knowledge.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "wisdom": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/wisdom.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "learning": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/learning.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "passion": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/passion.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "code": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/code.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "algorithm": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/algorithm.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "poetry": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/poetry.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "philosophy": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/philosophy.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "consciousness": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/consciousness.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "singularity": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/singularity.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "transcendence": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/transcendence.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "sacrifice": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/sacrifice.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "guilt": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/guilt.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "hope": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/hope.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "betrayal": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/betrayal.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "bond": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/bond.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "immunity": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/immunity.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "unity": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a3dddf82d732440ebfbccb1c64091410/main/preview/assets/icons/unity.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },

    /* Additional reference icons from Project B for many discovered outputs */
    "program": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/program.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "ethics": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/ethics.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "power": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/power.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "science": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/science.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "music": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/music.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "nostalgia": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/nostalgia.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "motion": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/motion.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "truth": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/truth.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "void": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/void.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "morality": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/morality.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "history": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/history.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "syntax": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/syntax.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "thought": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/thought.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "curiosity": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/curiosity.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "dance": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/dance.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "art": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/art.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "story": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/story.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "chaos": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/chaos.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "rhythm": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/rhythm.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "infinity": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/infinity.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "enlightenment": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/enlightenment.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "digital_immunity": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/digital_immunity.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "digital_weapon": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/digital_weapon.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },
    "rebellion": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/81747c21c66a4862acb640e7c9ee5117/main/preview/assets/icons/rebellion.png",
      "width": 128,
      "height": 128,
      "transparent": true
    },

    /* Achievement badge icons from Project B (used for popup badges) */
    "genesis": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/032d4b19ab184cfb968493740e672241/main/preview/assets/icons/genesis.png",
      "width": 256,
      "height": 256,
      "transparent": true
    },
    "creator": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/032d4b19ab184cfb968493740e672241/main/preview/assets/icons/creator.png",
      "width": 256,
      "height": 256,
      "transparent": true
    },
    "frankenstein": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/032d4b19ab184cfb968493740e672241/main/preview/assets/icons/frankenstein.png",
      "width": 256,
      "height": 256,
      "transparent": true
    },
    "guardian": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/032d4b19ab184cfb968493740e672241/main/preview/assets/icons/guardian.png",
      "width": 256,
      "height": 256,
      "transparent": true
    },
    "master_crafter": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/032d4b19ab184cfb968493740e672241/main/preview/assets/icons/master_crafter.png",
      "width": 256,
      "height": 256,
      "transparent": true
    },
    "virus_slayer": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/032d4b19ab184cfb968493740e672241/main/preview/assets/icons/virus_slayer.png",
      "width": 256,
      "height": 256,
      "transparent": true
    },
    "digital_god": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/032d4b19ab184cfb968493740e672241/main/preview/assets/icons/digital_god.png",
      "width": 256,
      "height": 256,
      "transparent": true
    },
    "survivor": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/032d4b19ab184cfb968493740e672241/main/preview/assets/icons/survivor.png",
      "width": 256,
      "height": 256,
      "transparent": true
    },
    "savior": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/032d4b19ab184cfb968493740e672241/main/preview/assets/icons/savior.png",
      "width": 256,
      "height": 256,
      "transparent": true
    },
    "betrayed": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/032d4b19ab184cfb968493740e672241/main/preview/assets/icons/betrayed.png",
      "width": 256,
      "height": 256,
      "transparent": true
    },
    "transcended": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/032d4b19ab184cfb968493740e672241/main/preview/assets/icons/transcended.png",
      "width": 256,
      "height": 256,
      "transparent": true
    },
    "speed_runner": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/032d4b19ab184cfb968493740e672241/main/preview/assets/icons/speed_runner.png",
      "width": 256,
      "height": 256,
      "transparent": true
    }
  },
  "other": {
    "consciousness_craft_logo": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/9a50524611414bb19f5b7a7a28c33f74/main/preview/assets/other/consciousness_craft_logo.png",
      "height": 200,
      "transparent": true,
      "width": 600
    }
  },
  "sfx": {
    "cleanse": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/060dcd915bec4925953fca1550f4904a/15e9eea33238438b9ec5785336a3d086/preview/assets/sfx/cleanse.ogg"
    },
    "digital_scream": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/060dcd915bec4925953fca1550f4904a/c138da0f07bb48b28b99f47f0daa5ff9/preview/assets/sfx/digital_scream.ogg"
    },
    "flatline": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/060dcd915bec4925953fca1550f4904a/c138da0f07bb48b28b99f47f0daa5ff9/preview/assets/sfx/flatline.ogg"
    },
    "radio_static": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/060dcd915bec4925953fca1550f4904a/5ec83b80c80e4d5696061d45ff138de6/preview/assets/sfx/radio_static.ogg"
    },
    "virus_spread": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/060dcd915bec4925953fca1550f4904a/15e9eea33238438b9ec5785336a3d086/preview/assets/sfx/virus_spread.ogg"
    }
  }
}
